import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AlertError from '../../common/AlertError';
import Popup from '../../common/Popup';
import * as constants from '../../../redux/actionTypes/errorActionTypes';


class DocketError extends Component {
  onClose = () => {
    this.props.dispatch({
      type: constants.RESET_VALIDATION_ERROR,
    });
  }

  render() {
    if (this.props.popupErrors) {
      return (
        <Popup show
               clsName="docket-error"
               topBarTitle="Reminder!"
               onClose={this.onClose}>
          <div className="error-text">
            { this.props.popupErrors.messages }
          </div>
        </Popup>
      );
    }
    if (this.props.alertErrors) {
      return (
        <AlertError errors={this.props.errors} />
      );
    }
    return null;
  }
}

DocketError.defaultProps = {
  errors: null,
  popupErrors: null,
  alertErrors: null,
};

DocketError.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.any,
  popupErrors: PropTypes.any,
  alertErrors: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null,
    alertErrors: state.get('searchErrors') ? state.get('searchErrors').toJS() : null,
  };
}

export default connect(mapStateToProps)(DocketError);



// WEBPACK FOOTER //
// ./src/components/case/docket/DocketError.jsx